import {EventModel} from '../EventModel/Event.model';

export class BaseModel {
  event?: EventClass = new EventClass();
}

export class EventClass {
  data?: EventModel[] = [];
}
